import { computed, inject } from 'vue';

const useScreenSize = () => {
	const screenSize = inject<() => 0 | 1 | 2 | 3 | 4>('screenSize');
	if (typeof screenSize === 'undefined') {
		console.warn('No screenSize provided!');
		return computed(() => 0);
	}
	return computed(() => screenSize());
};

export default useScreenSize;
